import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import DailyHaikuCard from "../components/DailyHaikuCard";

export default function DailyHaiku() {
  return (
    <div data-testid="daily-haiku-page">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-24 grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-4"
        >
          <span className="hanko text-primary text-3xl">日々の句</span>
          <h1 className="font-serif font-light text-5xl md:text-6xl tracking-tighter mt-4 leading-[0.95]">
            Daily<br />Haiku
          </h1>
          <p className="mt-6 text-muted-foreground leading-relaxed max-w-sm">
            Each day the house offers a single verse from Bashō's own hand — one moment of
            season to carry with you. Return tomorrow for another, or draw one at random now.
          </p>
          <Link
            to="/basho"
            className="mt-8 inline-block text-sm border-b border-foreground/30 pb-1 hover:border-primary hover:text-primary transition-colors"
          >
            Read the life of Bashō
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-8 border border-border p-6 sm:p-8 md:p-14 bg-muted/20"
        >
          <DailyHaikuCard variant="full" />
        </motion.div>
      </section>
    </div>
  );
}
